import { render, staticRenderFns } from "./TqLogin.vue?vue&type=template&id=f84605a2&scoped=true&"
import script from "./TqLogin.vue?vue&type=script&lang=js&"
export * from "./TqLogin.vue?vue&type=script&lang=js&"
import style0 from "./TqLogin.vue?vue&type=style&index=0&id=f84605a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84605a2",
  null
  
)

export default component.exports